const envDependentCookies = ["accessToken", "refreshToken", "expiresAt"];

const renameEnvDependentCookie = name => {
  if (envDependentCookies.includes(name)) {
    const env = process.env.REACT_APP_ENVIRONMENT;
    if (env !== "prod") name = env + "_" + name;
  }
  return name;
};
// Cookies (the tokens among them) stay on the page's own host, e.g. fojw.routetitan.com, and off plain
// http: the parent domain also has third-party hosts (Mailgun and SendGrid link tracking, CloudFront
// sites) that must never receive them.
const hostName = window.location.hostname;
const domainName = hostName.split(".").slice(-2).join(".") || "routetitan.com";

// Cookies used to be set on the whole parent domain; drop that copy on every write and erase, so the
// host cookie is the only one read.
const dropParentCopy = name => {
  document.cookie = `${name}=; Max-Age=-99999999;domain=.${domainName};path=/`;
};

export function setCookie(name, value, days, domain = hostName) {
  let expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else expires = "";
  name = renameEnvDependentCookie(name);
  if (process.env.NODE_ENV === "production") dropParentCopy(name);
  document.cookie =
    name +
    "=" +
    value +
    expires +
    (process.env.NODE_ENV === "production" && domain
      ? `;domain=${domain};path=/;secure`
      : "");
}

export function getCookie(name) {
  name = renameEnvDependentCookie(name);
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function eraseCookie(name, domain = hostName) {
  name = renameEnvDependentCookie(name);
  if (process.env.NODE_ENV === "production") dropParentCopy(name);
  document.cookie =
    name +
    `=; Max-Age=-99999999${process.env.NODE_ENV === "production" && domain
      ? `;domain=${domain};path=/`
      : ""
    }`;
}

export function clearAllCookies() {
  const cookies = document.cookie.split(";").map(cookie => cookie.trim()).filter(Boolean);
  const domainsToTry = [window.location.hostname, `.${window.location.hostname}`];
  // also include top-level domain (e.g. narmin.com) when hostname has subdomains
  const hostParts = window.location.hostname.split(".");
  if (hostParts.length > 2) {
    domainsToTry.push(`.${hostParts.slice(-2).join('.')}`);
  }

  cookies.forEach(cookie => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    // Try removing cookie without domain and with a few domain variants
    try {
      // Remove cookie for default path
      document.cookie = `${name}=; Max-Age=0; path=/`;
      domainsToTry.forEach(domain => {
        document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain}`;
      });
    } catch (e) {
      // ignore and continue
    }
  });
}
